/**
 * @module app.shared
 */

import { FrameworkConfiguration, PLATFORM } from 'aurelia-framework';

export function configure(config: FrameworkConfiguration) {
    config.globalResources([
        // attributes
        PLATFORM.moduleName('./attributes/ess-body-class-attribute'),
        PLATFORM.moduleName('./attributes/ess-capture-focus-attribute'),
        PLATFORM.moduleName('./attributes/ess-collapse-attributes'),
        PLATFORM.moduleName('./attributes/ess-focusable-attribute'),
        PLATFORM.moduleName('./attributes/ess-icon-attribute'),
        PLATFORM.moduleName('./attributes/ess-loading-attribute'),
        PLATFORM.moduleName('./attributes/ess-position-attributes'),
        PLATFORM.moduleName('./attributes/ess-row-class-attribute'),
        PLATFORM.moduleName('./attributes/ess-selectable-listbox-attribute'),
        PLATFORM.moduleName('./attributes/ess-scroll-attribute'),
        PLATFORM.moduleName('./attributes/ess-scrollbar-attribute'),
        PLATFORM.moduleName('./attributes/ess-tooltip-attribute'),
        PLATFORM.moduleName('./attributes/ess-validate-attribute'),
        PLATFORM.moduleName('./attributes/ess-tabs-attribute'),
        PLATFORM.moduleName('./attributes/sortable-attribute'),
        PLATFORM.moduleName('./attributes/href-attribute'),
        PLATFORM.moduleName('./attributes/test-id-attribute'),
        PLATFORM.moduleName('./attributes/test-group-attribute'),
        PLATFORM.moduleName('./attributes/trigger-validation-attribute'),
        PLATFORM.moduleName('./attributes/direct-focus-input-attribute'),

        // binding-behaviors
        PLATFORM.moduleName('./binding-behaviors/deprecated/aurelia-binding-behaviors'),
        PLATFORM.moduleName('./binding-behaviors/event-binding-behaviors'),
        PLATFORM.moduleName('./binding-behaviors/sync-binding-behavior'),

        // elements
        PLATFORM.moduleName('./elements/ess-badge'),
        PLATFORM.moduleName('./elements/ess-card'),
        PLATFORM.moduleName('./elements/ess-context-menu'),
        PLATFORM.moduleName('./elements/ess-dialog'),
        PLATFORM.moduleName('./elements/ess-dropdown'),
        PLATFORM.moduleName('./elements/ess-dynamic-grid'),
        PLATFORM.moduleName('./elements/ess-filter'),
        PLATFORM.moduleName('./elements/ess-horizontal-nav-menu'),
        PLATFORM.moduleName('./elements/ess-hscroll'),
        PLATFORM.moduleName('./elements/ess-info'),
        PLATFORM.moduleName('./elements/ess-notifications'),
        PLATFORM.moduleName('./elements/ess-pager'),
        PLATFORM.moduleName('./elements/ess-rule'),
        PLATFORM.moduleName('./elements/ess-sortable-list'),
        PLATFORM.moduleName('./elements/ess-table'),
        PLATFORM.moduleName('./elements/ess-tabs-horizontal'),
        PLATFORM.moduleName('./elements/ess-tabs-vertical'),
        PLATFORM.moduleName('./elements/ess-tooltip'),
        PLATFORM.moduleName('./elements/ess-transitional-link'),

        // gauges
        PLATFORM.moduleName('./elements/gauges/ess-bar-gauge'),
        PLATFORM.moduleName('./elements/gauges/ess-half-donut-gauge'),

        // elements/buttons
        PLATFORM.moduleName('./elements/ess-button'),

        // elements/display
        PLATFORM.moduleName('./elements/display/ess-markdown'),
        PLATFORM.moduleName('./elements/display/ess-more'),
        PLATFORM.moduleName('./elements/display/ess-multiline.html'),
        PLATFORM.moduleName('./elements/display/ess-required-asterisk.html'),
        PLATFORM.moduleName('./elements/display/ess-ribbon-link'),

        // elements/forms
        PLATFORM.moduleName('./elements/forms/ess-autocomplete'),
        PLATFORM.moduleName('./elements/forms/ess-checkbox'),
        PLATFORM.moduleName('./elements/forms/ess-currency'),
        PLATFORM.moduleName('./elements/forms/ess-date'),
        PLATFORM.moduleName('./elements/forms/ess-daterange'),
        PLATFORM.moduleName('./elements/forms/ess-datetime'),
        PLATFORM.moduleName('./elements/forms/ess-file'),
        PLATFORM.moduleName('./elements/forms/ess-file-progress.html'),
        PLATFORM.moduleName('./elements/forms/ess-form'),
        PLATFORM.moduleName('./elements/forms/ess-integer'),
        PLATFORM.moduleName('./elements/forms/ess-number'),
        PLATFORM.moduleName('./elements/forms/ess-radio'),
        PLATFORM.moduleName('./elements/forms/ess-select'),
        PLATFORM.moduleName('./elements/forms/ess-switch'),
        PLATFORM.moduleName('./elements/forms/ess-text'),
        PLATFORM.moduleName('./elements/forms/ess-textarea'),
        PLATFORM.moduleName('./elements/forms/ess-time'),

        // elements/icons
        PLATFORM.moduleName('./elements/icons/ess-icon-activate.html'),
        PLATFORM.moduleName('./elements/icons/ess-icon-help'),
        PLATFORM.moduleName('./elements/icons/ess-icon-required-info.html'),
        PLATFORM.moduleName('./elements/icons/ess-icon-warning'),

        // elements/layout
        PLATFORM.moduleName('./elements/layout/ess-lockout'),

        // value-converters
        PLATFORM.moduleName('./value-converters/array-converters'),
        PLATFORM.moduleName('./value-converters/datetime-converters'),
        PLATFORM.moduleName('./value-converters/debug-converters'),
        PLATFORM.moduleName('./value-converters/environment-converters'),
        PLATFORM.moduleName('./value-converters/escape-converters'),
        PLATFORM.moduleName('./value-converters/has-flag-value-converter'),
        PLATFORM.moduleName('./value-converters/i18n-converters'),
        PLATFORM.moduleName('./value-converters/join-converters'),
        PLATFORM.moduleName('./value-converters/logic-converters'),
        PLATFORM.moduleName('./value-converters/numeric-converters'),
        PLATFORM.moduleName('./value-converters/property-converters'),
        PLATFORM.moduleName('./value-converters/style-converters'),
        PLATFORM.moduleName('./value-converters/text-converters'),
        PLATFORM.moduleName('./value-converters/test-id-converters'),

        //formatters
        PLATFORM.moduleName('./elements/format-more.html'),
        PLATFORM.moduleName('./elements/format-time-zone.html'),

        // view engine hooks
        PLATFORM.moduleName('./hooks/feature-view-engine-hooks')
    ]);
}
